import { CardTypes } from 'state/payment/types';

export const isApplePay = (accountIdentifier: string | null) =>
  accountIdentifier === CardTypes.APPLE_PAY;

export const isGooglePay = (accountIdentifier: string | null) =>
  accountIdentifier === CardTypes.GOOGLE_PAY;
